import { useQuery } from '@tanstack/react-query';

import { listRules } from '../../lib/api/endpoints';

export const rulesKeys = {
  all: ['rules'] as const,
};

export function useRules() {
  return useQuery({
    queryKey: rulesKeys.all,
    queryFn: listRules,
  });
}
